<template>
  <div>
    <div class="fc-text-center">
    	<img class="paystatus_img" src="/static/img/successIcon.png">
      <p class="paystatus_title">{{$t('m.PayStatusSuccess_title')}}</p>
      <div class="fc-btn-main backhomepage fc-mar-t-super" @click="goHome">{{$t('m.goBack')}}</div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'success',
    data() {
      return {

      }
    },
    watch: {

    },
    filters: {

    },
    mounted() {
      //  this.textSize();
       this.getLang();
    },
    methods: {
      //字体大小
      textSize(){
      	! function(a) {
      		function b() {
      			var b = g.getBoundingClientRect().width;
      			a.rem = (b / 7.5 > 100 ? 100 : (b / 7.5 < 300 / 7.5 ? 300 / 7.5 : b / 7.5)), g.style.fontSize = a.rem + "px"
      			//a.rem = (b / 7.5), g.style.fontSize = a.rem + "px"
      		}
      		var g = a.document.documentElement,
      			e;
      		a.addEventListener("resize", function() {
      			clearTimeout(e), e = setTimeout(b, 300)
      		}, !1), a.addEventListener("pageshow", function(a) {
      			a.persisted && (clearTimeout(e), e = setTimeout(b, 300))
      		}, !1), b()
      	}(window);
      },
      getLang() {
        var box = document.getElementById("app");
        let language = navigator.language || navigator.browserLanguage;
        if (language == 'ar') {
          box.style.direction = 'rtl';
        }else{
          box.style.direction = 'ltr';
        }
      },
      goHome(){
      	this.$router.push({
      	  path: '/'
      	})
      }

    },

  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/success.vue